module.exports = __webpack_public_path__ + "files/49b7369a22d82a3636fdd01fa725d6cc.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-1.png
// module id = 506
// module chunks = 76